import { APIClient } from "@velzon/utils/axios/api_helper.js";

const AxiosClient = new APIClient()
const login = payload => AxiosClient.create('/auth/user-login', payload);
const refreshToken = () => AxiosClient.create('/auth/refresh-token')
const forgetPassword = payload => AxiosClient.create('/auth/forgot-password', payload);
const resetPassword = payload => AxiosClient.create('/auth/reset-password', payload);
const validateToken = (token) =>
  AxiosClient.get(
    '/auth/validate-token',
    { token }
  );
const logout = () => AxiosClient.create('/auth/logout')

export {
  login,
  refreshToken,
  forgetPassword,
  resetPassword,
  logout,
  validateToken
}